module.exports = __webpack_public_path__ + "img/hausAlt.3973b3e2.png";